import { Pipe, PipeTransform } from '@angular/core';
import { Data } from '@cbre/digger';
import { ReportRecord } from '../../models/report.model';

/**
 * If an array of report records are passed as an input to the pipe, it extracts the
 * data from each object and returns back an edp records.
 */
@Pipe({
  name: 'extractRecordsFromReportRecordFn',
  standalone: false,
})
export class ExtractRecordsFromReportRecordFnPipe implements PipeTransform {
  transform(reportRecords: ReportRecord[]): Data[] {
    return reportRecords.reduce((acc, perRecord) => {
      const records = Array.isArray(perRecord?.data) ? perRecord?.data : [perRecord?.data];
      return [...acc, ...records];
    }, []);
  }
}
